import React  from 'react';
import { connect } from 'react-redux';
import { Paper, FlatButton, FontIcon } from 'material-ui';
import CreateTemplateGroup from './create-group-wizard';
import R from 'ramda';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
class CreateTemplateGroupRouter extends React.Component {
  render() {
    return (
      <Paper style={{ width: '800px', margin: 'auto auto 64px auto' }}>
        <div style={{ backgroundColor: '#00bcd4', color: '#fff', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'space-between' }}>
          <h4 style={{ width: '50%', color: '#FFFFFF', fontWeight: '500', paddingRight: '32px', textAlign: 'right' }}>Create Template Group</h4>
          <FlatButton
            icon={<FontIcon className="tc-icon-arrow_back" color="white" />}
            label="back"
            style={{ color: 'white' }}
            onTouchTap={() => this.context.router.goBack()}
          />
        </div>
        <div style={{ padding: '12px 12px 24px 12px' }}>
          <CreateTemplateGroup
            afterCreationFn={() => this.context.router.push('/contracting/template-list?showType=group')}
          />
        </div>
      </Paper>
    );
  }
}

CreateTemplateGroupRouter.propTypes = {
  updateProps: React.PropTypes.func,
  getTemplates: React.PropTypes.func,
  createGroupError: React.PropTypes.string,
  allContractPeriods: React.PropTypes.array,
};
const mapStateToProps = ({ contracting }) => ({
  allContractPeriods: contracting.templateList.toJS().allContractPeriods,
});
CreateTemplateGroupRouter.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps)(CreateTemplateGroupRouter);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-group/create-group-router.jsx